/**
 * 环境与路径配置
 * ------------------------------------------------------------------
 * 后端已去掉 context-path，不再有 /admin-api 前缀。
 *   mall-admin 后端直接跑在端口 8081，请求路径如 /admin/login
 *
 * 本地开发:
 *   API_PREFIX = '/admin-api'（统一前缀），
 *   config/index.js proxyTable 匹配 /admin-api，pathRewrite 去掉前缀，转发到 http://127.0.0.1:8081
 *
 * 线上:
 *   API_PREFIX = '/admin-api'（统一前缀），
 *   nginx location /admin-api/ rewrite 去掉前缀，转发到 http://127.0.0.1:8081
 *
 * 作用: 与 mall-app-web 的 /portal-api 前缀区分，便于 nginx 统一分流
 * ------------------------------------------------------------------
 */

const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
// const IS_LOCAL = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(hostname)
const IS_LOCAL = false

// URL 根路径（hash/history 模式的 base）
// 独立域名根路径部署，本地线上都用 ''
export const ROUTER_BASE = ''

// API 请求前缀（加 /admin-api，通过 proxy/nginx rewrite 去掉）
export const API_PREFIX = '/admin-api'

// 本地开发直连端口（保留字段，当前由 API_PREFIX 统一处理）
export const LOCAL_DIRECT_BASE = ''

export default {
  IS_LOCAL,
  ROUTER_BASE,
  API_PREFIX,
  LOCAL_DIRECT_BASE
}



// WEBPACK FOOTER //
// ./src/config/env.js